import { addUuidBatch } from '@gp/utils/common';
import { getWeekDateOfDPSReport, formatComment } from '../../utils';

import type { IDPSReportDTOV2, IDPSReportVOV2 } from '@gp/types/dpsReport/v2';

/**
 * 转换DPS周报（DTO）为 DPS周报（VO）
 * @param dpsReport DPS周报（DTO）
 * @return DPS周报（VO）
 */
export const formatDPSReport = (dpsReport?: IDPSReportDTOV2 | null): IDPSReportVOV2 | null => {
  if (!dpsReport) return null;

  const {
    comment,
    hightlights,
    changes,
    miscellaneous,
    calendar: calendars,
    start_date: startDate,
    end_date: endDate,
  } = dpsReport;

  // 转换接口返回的开始日期、结束日期 为 符合DPS周报要求的日期（星期一～星期五）
  const {
    startDateM: startDateMDPSReportWeek,
    startDate: startDateDPSReportWeek,
    endDate: endDateDPSReportWeek,
  } = getWeekDateOfDPSReport(startDate, endDate);

  const commentTmp = formatComment(comment);

  const hightlightsTmp = addUuidBatch(hightlights);

  const changesTmp = addUuidBatch(changes);

  const miscellaneousTmp = addUuidBatch(miscellaneous);

  const calendarsTmp = addUuidBatch(calendars);

  return {
    ...dpsReport,
    start_date_dps_report_week: startDateDPSReportWeek,
    end_date_dps_report_week: endDateDPSReportWeek,
    year: startDateMDPSReportWeek?.get('year') || Number.NaN,
    weeks_in_year: startDateMDPSReportWeek?.weeks() || Number.NaN,
    comment: commentTmp || '',
    hightlights: hightlightsTmp || [],
    changes: changesTmp || [],
    miscellaneous: miscellaneousTmp || [],
    calendar: calendarsTmp || [],
  };
};
